module.exports = __webpack_public_path__ + "img/helper-disable.3eff522f.svg";